import createModelStore from "../../utils/createModelStore";
import WorkShift from "../../services/WorkShift";

const workShifts = createModelStore<WorkShift.Model, "workShifts">(
	"workShifts",
);

export default workShifts;
